import '../../style/index.less';
import './index.less';



// WEBPACK FOOTER //
// ./_antd1.11.2/spin/style/index.js